module.exports = __webpack_public_path__ + "static/logistics-cust-booking@2x-9f6cd540449fdea11cf69490b0d25fed.png";